import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="not-found-container">
      <h1>404</h1>
      <h2>Página Não Encontrada</h2>
      <p>A página que você está procurando não existe ou foi movida.</p>
      <Link to="/" className="back-button">
        Voltar para o Dashboard
      </Link>
    </div>
  );
};

export default NotFound;
